import React from "react";
import { Grid } from "@material-ui/core";
import SelectedRangeSales from "./SelectedRangeSales";

const RangeInsight: React.FC = () => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <SelectedRangeSales />
            </Grid>
        </Grid>
    );
};

export default RangeInsight;
